import type { IDataState } from "@/store/modules/data";
import { DEFAULT_LIST_SCOPE } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import type { IState } from "@/store";
import { Methods } from "@/models/methods";
import type { ApiPathGetter } from "@/models/api";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath:
    (s, g, rS, { isAdminContext }): ApiPathGetter =>
    () => {
      const admin = `api/admin/clients_fields`;
      const client = `api/clients_fields`;
      const contextual = isAdminContext ? admin : client;
      return { client, admin, contextual };
    },
  scope: () => id => {
    return `$clients_field_${id}`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: `${getters.apiPath().contextual}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );
  },
  get: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/get",
      {
        ...payload,
        path: `${getters.apiPath().contextual}/${payload?.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );
  },
  create: async ({ dispatch, commit, getters }, payload) => {
    const customField = await dispatch(
      "data/create",
      {
        ...payload,
        path: `${getters.apiPath().admin}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );

    await commit(
      "data/addSingleItemList",
      {
        scope: DEFAULT_LIST_SCOPE,
        path: `data.${customField.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS,
        data: customField
      },
      { root: true }
    );

    return customField;
  },

  update: async ({ dispatch, commit, getters }, payload) => {
    const customField = await dispatch(
      "data/update",
      {
        data: payload.data,
        path: `${getters.apiPath().admin}/${payload?.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );

    await commit(
      `data/updateSingleItemList`,
      {
        scope: payload.scope,
        path: `data.${payload?.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS,
        data: customField
      },
      { root: true }
    );

    return customField;
  },
  remove: async ({ dispatch, commit, getters }, payload) => {
    const response = await dispatch(
      "data/remove",
      {
        path: `${getters.apiPath().admin}/${payload?.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );

    await commit(
      "data/binSingleItemList",
      {
        scope: DEFAULT_LIST_SCOPE,
        path: `data.${payload.id}`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS
      },
      { root: true }
    );
    return response;
  },
  reorder: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/callApi",
      {
        method: Methods.PUT,
        path: `${getters.apiPath().admin}/order`,
        storeModule: DataModules.CUSTOM_FIELDS_CLIENTS,
        requestConfig: { data: payload.data }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
